import { Redirect, Stack } from 'expo-router';
import React from 'react';

import { useAuthStore } from '@/store/authStore';
import { PROVIDER_HOME_PATH, isProviderUser } from '@/utils/user-role';

export default function ClientLayout() {
  const user = useAuthStore((state) => state.user);

  // Espelho da guarda do grupo de prestador: prestador sempre prevalece.
  if (user && isProviderUser(user)) {
    return <Redirect href={PROVIDER_HOME_PATH} />;
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    />
  );
}
